'use client';

import ComplianceStatement from '@/components/ComplianceStatement';

export default function GDPRPage() {
  return <ComplianceStatement />;
}